import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProfileService } from '../profile.service';
import { SessionStorageService } from 'src/app/core/services/session-storage.service';
import { VerificationRequestType } from 'src/app/core/interfaces/profilesettings';

@Component({
  standalone: false,
  selector: 'app-verification-callback',
  templateUrl: './verification-callback.component.html',
  styleUrls: ['./verification-callback.component.scss']
})
export class VerificationCallbackComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private profileService: ProfileService,
    private sessionStorage: SessionStorageService,
  ) { }

  ngOnInit(): void {
    const provider = this.route.snapshot.paramMap.get('provider');
    const queryParams = this.route.snapshot.queryParams;

    if (this.router) {
      if (!provider || Object.keys(queryParams).length === 0) {
        this.router.navigateByUrl('');
      }

      switch (provider) {
        case 'didit':
          const sessionId = this.route.snapshot.queryParamMap.get('verificationSessionId');

          this.profileService.verifyDiditSession({sessionId})
            .subscribe((response: any) => {
              const {response: res, status} = response || {};

              if (res && ['Approved', 'In Review'].includes(status)) {
                this.sessionStorage.store('requestType', VerificationRequestType.Compliance);
                this.router.navigate(['/verificationwizard'], {
                  state: { verificationStarted: true }
                });
              } else {
                this.router.navigate(['/verificationwizard']);
              }
            });
          break;

        default:
          this.router.navigateByUrl('');
          break;
      }
    }
  }

}
